(function(){
// Pure allowlist builder. Data is untrusted until checked and bound by staff.
function transferBundle(input) {
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/
      .test(input.inquiry_id || "")) throw Error("INVALID_INQUIRY_UUID");
  if (!Number.isFinite(Date.parse(input.submitted_at || ""))) throw Error("INVALID_TIME");
  const c = input.consent || {};
  const result = {version: 1, inquiry_id: input.inquiry_id,
    submitted_at: input.submitted_at, staff_verified: false, final_order_id: null,
    consent: {analytics: c.analytics === true, marketing: c.marketing === true,
      ad_user_data: ["GRANTED", "DENIED"].includes(c.ad_user_data) ? c.ad_user_data : "UNKNOWN"}};
  // Evidence remains untrusted browser data until merchant verification. Never
  // infer a grant or staff approval from an allowlisted field.
  const e = input.consent_evidence;
  if (e && ["GRANTED","DENIED","UNKNOWN"].includes(e.explicit_ad_user_data) &&
      Number.isFinite(Date.parse(e.recorded_at)) &&
      Date.parse(e.recorded_at) <= Date.parse(input.submitted_at))
    result.consent_evidence = {
      mapping_approved: e.mapping_approved === true,
      explicit_ad_user_data: e.explicit_ad_user_data,
      recorded_at: new Date(e.recorded_at).toISOString()
    };
  if (result.consent.ad_user_data === "GRANTED" &&
      !(result.consent_evidence?.mapping_approved === true &&
        result.consent_evidence?.explicit_ad_user_data === "GRANTED"))
    result.consent.ad_user_data = "UNKNOWN";
  if (result.consent.analytics && /^[0-9]+\.[0-9]+$/.test(input.client_id || ""))
    result.client_id = input.client_id;
  const click = input.click;
  if (result.consent.marketing && click &&
      ["gclid", "gbraid", "wbraid"].includes(click.kind) &&
      /^[A-Za-z0-9_-]{1,512}$/.test(click.value || "") &&
      Number.isFinite(Date.parse(click.observed_at || "")) &&
      Date.parse(click.observed_at) <= Date.parse(input.submitted_at))
    result.click = {kind: click.kind, value: click.value, observed_at: click.observed_at};
  return result;
}

// Pure adapter; no consent is recorded or presumed, and no destination is called.
// Explicit ad-data permission is supplied by a separately approved consent interface.
function bindConsent(privacy, explicitAdData, approvedMapping = false) {
  let current = {}, analytics = false, marketing = false, saleAllowed = false;
  try {
    current = privacy?.currentVisitorConsent?.() || {};
    analytics = privacy?.analyticsProcessingAllowed?.() === true;
    marketing = privacy?.marketingAllowed?.() === true;
    saleAllowed = privacy?.saleOfDataAllowed?.() === true;
  } catch (_) { return {analytics:false, marketing:false, ad_user_data:"UNKNOWN"}; }
  // Never translate email marketing, location defaults, or marketingAllowed alone to GRANTED.
  let ad = "UNKNOWN";
  if (explicitAdData === "DENIED" || current.marketing === "no" ||
      current.sale_of_data === "no") ad = "DENIED";
  else if (approvedMapping === true && explicitAdData === "GRANTED" &&
           current.marketing === "yes" && marketing && saleAllowed) ad = "GRANTED";
  return {analytics, marketing, ad_user_data:ad};
}

/* DRAFT ONLY. Prepended transferBundle() by generator. No fetch, app proxy or purchase.
 * Preserve the existing native contact form action, redirects and business logic.
 */
(function () {
  "use strict";
  const node = document.getElementById("artisan-native-tracking-config");
  if (!node) return;
  let cfg;
  try { cfg = JSON.parse(node.textContent); } catch (_) { return; }
  if (cfg.enabled !== true) return;
  const KEY = "artisan-native-attribution-v1", PENDING = "artisan-native-inquiry-v1";
  let clientId = null, clickMemory = null;
  const read = (key) => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  function consent() {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    let ad = "UNKNOWN";
    // No automatic promotion of marketing=true to ad_user_data=GRANTED.
    try {
      const v = window.ArtisanConsent?.adUserData?.();
      if (["GRANTED", "DENIED"].includes(v)) ad = v;
    } catch (_) {}
    return bindConsent(p, ad, cfg.consent_mapping_approved === true);
  }
  function refresh() {
    const c = consent();
    if (!c.analytics) clientId = null;
    else if (/^G-[A-Z0-9]+$/.test(cfg.measurement_id || "") && window.gtag)
      window.gtag("get", cfg.measurement_id, "client_id", value => {
        if (consent().analytics && /^[0-9]+\.[0-9]+$/.test(value || "")) clientId = value;
      });
    if (!c.marketing) {
      clickMemory = null;
      try { localStorage.removeItem(KEY); } catch (_) {}
      return;
    }
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(KEY)); } catch (_) {}
    const now = Date.now(), maxDays = cfg.retention_days;
    // An explicit approved retention value is required; never default to indefinite storage.
    if (!Number.isInteger(maxDays) || maxDays < 1 || maxDays > 90) {
      clickMemory = null;
      try { localStorage.removeItem(KEY); } catch (_) {}
      return;
    }
    if (saved && (now - Date.parse(saved.observed_at) < 0 ||
        now - Date.parse(saved.observed_at) >= maxDays * 86400000 ||
        !Number.isFinite(Date.parse(saved.observed_at)))) saved = null;
    const query = new URLSearchParams(location.search);
    const kind = ["gclid", "gbraid", "wbraid"].find(k =>
      /^[A-Za-z0-9_-]{1,512}$/.test(query.get(k) || ""));
    // Preserve the original eligible click rather than overwrite it with later visits.
    // At inquiry it is frozen into the merchant record. No raw URL is stored.
    clickMemory = saved || (kind ? {kind, value: query.get(kind), observed_at: new Date(now).toISOString()} : null);
    try {
      if (clickMemory) localStorage.setItem(KEY, JSON.stringify(clickMemory));
      else localStorage.removeItem(KEY);
    } catch (_) {}
  }
  function bind() {
    const form = document.getElementById("FreightReviewForm");
    if (!form || form.dataset.artisanNativeBound) return;
    form.dataset.artisanNativeBound = "true";
    const reference = document.createElement("input"), bundle = document.createElement("input");
    reference.type = bundle.type = "hidden";
    reference.name = "contact[Inquiry reference]";
    bundle.name = "contact[Merchant tracking bundle]";
    form.append(reference, bundle);
    form.addEventListener("submit", () => {
      // NEVER prevent submission or await tracking. A tracking fault must not lose an inquiry.
      try {
        refresh(); // Recheck consent and expiry at submission, not just page load.
        const prior = read(PENDING), now = Date.now();
        const inquiry = prior && !prior.accepted && now - prior.created_at < 86400000
          ? prior : {id: crypto.randomUUID(), created_at: now, accepted: false};
        const currentConsent = consent(), submittedAt = new Date(now).toISOString();
        const result = transferBundle({inquiry_id: inquiry.id,
          submitted_at: submittedAt, consent: currentConsent,
          consent_evidence: {mapping_approved:cfg.consent_mapping_approved === true,
            explicit_ad_user_data:currentConsent.ad_user_data, recorded_at:submittedAt},
          client_id: clientId, click: clickMemory});
        reference.value = inquiry.id;
        bundle.value = JSON.stringify(result); write(PENDING, inquiry);
      } catch (_) { reference.value = ""; bundle.value = ""; }
    });
  }
  function accepted() {
    if (!document.querySelector('[data-artisan-inquiry-accepted="true"]')) return;
    const p = read(PENDING);
    if (!p || p.accepted || Date.now() - p.created_at > 86400000) return;
    // Consume success even if consent denied, so later consent cannot replay an old inquiry.
    p.accepted = true; write(PENDING, p);
    if (consent().analytics && /^G-[A-Z0-9]+$/.test(cfg.measurement_id || "") && window.gtag)
      window.gtag("event", "generate_lead", {send_to: cfg.measurement_id,
        lead_type: "order_submission", order_flow: "freight_review"});
  }
  function init() { refresh(); bind(); accepted(); }
  document.addEventListener("visitorConsentCollected", refresh);
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures(
    [{name: "consent-tracking-api", version: "0.1"}], error => { if (!error) init(); });
})();

})();
